import React from 'react';
import { SettingType } from '../../../../../api/vault/publishEndpoints';
import { IProps } from './interfaces';
import {
  SocialDialogWithPreviewPlayer,
  SocialDialogHeader,
  SocialDialogTitle,
  SocialDialogActions,
  TitleField,
  DescriptionField,
} from '../../../../Shared/Publish/SocialDialog';
import { ClipsPreviewPlayer } from '../../../../Shared';
import { SelectedClipsTotalDuration } from '../../../../Shared/SelectedClipsPreview';
import { DialogContentContainer } from '../../../../Shared/styles/dialog';

const YouTubePublishDialog: React.FunctionComponent<IProps> = (props: IProps) => {
  const {
    onPublish,
  } = props;

  return (
    <SocialDialogWithPreviewPlayer settingType={SettingType.YouTube}>
      <SocialDialogHeader>
        <SocialDialogTitle />
        <SelectedClipsTotalDuration />
      </SocialDialogHeader>
      <DialogContentContainer>
        <ClipsPreviewPlayer
          thumbnailSelectable
        />
        <TitleField />
        <DescriptionField />
      </DialogContentContainer>
      <SocialDialogActions onPublish={onPublish} isProcessing={false} setIsProcessing={(processing) => { }} />
    </SocialDialogWithPreviewPlayer>
  );
};

export default YouTubePublishDialog;
